import EditRoundedIcon from '@mui/icons-material/EditRounded';
import Tooltip from '@mui/material/Tooltip';
import EventIcon from '@mui/icons-material/Event';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { EventData } from "./EventsContainer";
import { useAppDispatch } from "../../../../../state/state";
import { openModal } from "../../../../../state/ModalSlice/ModalSlice";
import { setFieldsForEditEventsModal } from "../../../../../state/ArbitrarySlice/ArbitratySlice";
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { useNavigate } from "react-router-dom";

export default function EventsListRenderer({ event }: { event: EventData }) {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const onClickEditEvent = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        dispatch(setFieldsForEditEventsModal({ eventId: event.id }))
        dispatch(openModal('EditEventsModalOpen'));
    }
  
    return (
        <div className="w-full" onClick={() => navigate(`/eventdetail/${event.id}`)}>
            <div className="flex cursor-pointer mt-2 shadow-md border-[1px] border-gray-300  hover:bg-gray-100  bg-white rounded-xl p-2  h-[7.5rem] w-full">
                <div className="rounded-lg overflow-hidden ">
                    <img className="h-[100%] aspect-square" src={event.ePromoImage} alt="event-image" />
                </div>
                <div className="ml-4 w-[87%] relative">
                    <div className="flex items-center justify-between w-full "><p className="text-cc_brand font-semibold">{event.eName}</p>
                        <p className={`text-xs ${event.isOpen ? "bg-cc_success" : "bg-cc_bg-paused"} rounded-lg px-2 py-1 text-white font-semibold`}>{event.isOpen ? "RGST OPEN" : "RGST CLOSED"}</p></div>
                    <div className="flex items-center justify-between w-full pt-1.5">
                        <div className="flex items-center gap-1">
                            <EventIcon fontSize="small" style={{ color: '#808080' }} />
                            <p className="text-sm">Date & Time: {new Date(event.eStartTime.seconds * 1000).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            })} - {new Date(event.eStartTime.seconds * 1000).toLocaleTimeString()}</p>
                        </div>
                    </div>
                    <div className="flex items-center justify-between w-full pt-1.5">
                        <div className="flex items-center gap-1">
                            <LocationOnOutlinedIcon fontSize="small" style={{ color: '#808080' }} />
                            <p className="text-sm">Venue : {event.eGeoLocation.placeName}</p>
                        </div>
                    </div>
                    <div className="flex items-center justify-between w-full pt-1.5">
                        <Tooltip title="Participants" placement="top">
                            <span className="text-sm">
                                <PeopleOutlineIcon fontSize="small" style={{ color: '#808080' }} /> {event.participants}
                            </span>
                        </Tooltip>
                    </div>
                    <Tooltip title="Edit Event" placement="top">
                        <div onClick={onClickEditEvent} className="absolute bottom-0 right-0 hover:bg-gray-300 rounded-full px-2 p-1.5">
                            <EditRoundedIcon
                                className="rounded-full"
                                fontSize="small"
                                style={{ color: '#808080' }}
                            />
                        </div>

                    </Tooltip>
                </div>
            </div>
        </div>
    )
}